import React from "react";
import useReveal from "../../hooks/useReveal";
import "./ProjectSteps.css";

const ProjectSteps = ({ title, steps }) => {
  const listRef = useReveal({ threshold: 0.1 });

  return (
    <section className="project-steps-section">
      <div className="project-steps-container">
        <h2 className="project-steps-title">{title}</h2>
        <div className="project-steps-list" ref={listRef}>
          {steps.map((step, index) => (
            <div
              key={step.number ?? index}
              className="project-step"
              style={{ "--step-delay": `${index * 120}ms` }}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectSteps;
